import { ReactNode } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";

type SliderProps = {
  children: ReactNode;
  config: {
    isAutoPlay: boolean;
    spaceBetween: number;
    slidesPerView: number;
    centeredSlides: boolean;
    speed: number;
    swiperClass: string;
    loop: boolean;
    navigation: boolean;
    autoPlay:
      | {
          delay: number;
          disableOnInteraction: boolean;
        }
      | boolean;
  };
};

function Slider({
  children,
  config: {
    isAutoPlay,
    spaceBetween,
    slidesPerView,
    centeredSlides,
    navigation,
    speed,
    loop,
    swiperClass,
    autoPlay,
  },
}: SliderProps) {
  return (
    <Swiper
      modules={isAutoPlay ? [Autoplay] : []}
      spaceBetween={spaceBetween}
      slidesPerView={slidesPerView}
      centeredSlides={centeredSlides}
      navigation={navigation}
      speed={speed}
      loop={loop}
      autoplay={autoPlay}
      className={swiperClass}
    >
      {children}
    </Swiper>
  );
}

export default Slider;
